import React from 'react';
import { FormattedMessage } from 'react-intl';
import BaseModal from '../../../_shared/components/BaseModal';
import { PostSaleLineItems } from '../../../_shared/types/postSale';

import {
  Body,
  Header,
  Title,
  GradientDivider,
  LeftArrowIcon,
  StyledCloseButton,
  StyledInformationIcon,
  TitleOwnershipInfoBox,
  TitleOwnershipContentWrapper
} from './Styles';
import FileUpload from '../../PaymentsOnHold/FileUpload';
import usePaymentsOnHoldFetchDocs from '../../../_shared/hooks/activity/usePaymentsOnHoldFetchDocs';

const PaymentsOnHoldUploadDocModal = ({ trade, statusKey, onClose }) => {
  const documentType = statusKey === PostSaleLineItems.OWNERSHIP ? 0 : 1;
  const previouslyUploadedDocuments = usePaymentsOnHoldFetchDocs(
    trade.id,
    documentType,
    {
      disabled: trade?.isEtrTrade
    }
  );
  if (!trade) {
    return null;
  }

  return (
    <BaseModal
      width={700}
      isOpen={Boolean(trade)}
      isClickEscClose
      isClickOverlayClose
      onRequestClose={onClose}
      padding="0px 18px 10px 18px"
      testId="payments-on-hold-upload-documents-modal"
    >
      <Header>
        <div>
          <StyledCloseButton
            onClick={onClose}
            data-testid="payments-on-hold-upload-documents-modal-close-top-button"
          >
            <LeftArrowIcon />
          </StyledCloseButton>
          <Title>
            {statusKey === PostSaleLineItems.OWNERSHIP ? (
              <FormattedMessage
                id="paymentsOnHold.uploadDocument.uploadOwnershipForVin"
                values={{ vin: trade.vin }}
              />
            ) : (
              <FormattedMessage
                id="paymentsOnHold.uploadDocument.uploadLienReleaseForVin"
                values={{ vin: trade.vin }}
              />
            )}
          </Title>
        </div>
      </Header>
      <GradientDivider />
      <Body>
        {statusKey === PostSaleLineItems.OWNERSHIP &&
        trade.dealerProvince === 'QC' ? (
          <TitleOwnershipInfoBox>
            <StyledInformationIcon />
            <TitleOwnershipContentWrapper>
              <FormattedMessage
                id="paymentsOnHold.uploadDocument.ownership.info"
                values={{ br: <br /> }}
              />
            </TitleOwnershipContentWrapper>
          </TitleOwnershipInfoBox>
        ) : (
          <></>
        )}
        <FileUpload
          trade={trade}
          documentType={statusKey === PostSaleLineItems.OWNERSHIP ? 0 : 1}
          previouslyUploadedDocs={previouslyUploadedDocuments}
          onClose={onClose}
        />
      </Body>
    </BaseModal>
  );
};

export default PaymentsOnHoldUploadDocModal;
